// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify } from "react-admin";
import * as React from "react";
import { Card, TextField,Button,
} from '@material-ui/core';
import {edit_limooplus_diet_type_form} from './index'
import { useForm } from "react-hook-form";
// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
      if (!regex.test(value)) {
        return "شماره موبایل صحیح نمیباشد";
      }
      return true;
    }
  };
export function EditLimooPlustDietType({ resetKey }) {
    interface IFormInput {
        mobile: string;
      }
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
      } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            mobile: null,
        },
      });
    const notify = useNotify()
      const [errorMessages, setErrorMessages] = React.useState([]);
      const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
    
      const onSubmit = async (data: IFormInput) => {
        setErrorMessages([]);
        setNetworkState("PENDING");
        const postData = {
            mobile: data.mobile,
        };
    
        edit_limooplus_diet_type_form(postData).then((res)=>{
            if (res.data.err) {
                setErrorMessages([res.data.err.details.messages[0]]);
                console.log('errorMessages',errorMessages);  
                setNetworkState("FAILED");
            }
            else{
                if (res.data) {
                    if (res.data.status === "SUCCESS") {
                      notify("     تغییر رژیم با موفقیت انجام شد", { type: 'success' })
                      resetKey(Date.now());
                      setNetworkState("SUCCESS");
                    }
                 
                }
            }
          
          }).catch((err)=>{
            console.log('err',err);
            
          })
       
    
      
        }
    return (
        <Card style={{margin:"1rem"}}>
              <h3 style={{fontFamily: 'IranSans-Medium',color:'rgb(71 68 68 / 87%)',marginRight:'3rem'}}>     تغییر رژیم لیمو پلاس به معمولی </h3>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          margin:"3rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("mobile", {
            required: "شماره موبایل  را وارد نمایید"
          })}
          error={!!errors.mobile}
          helperText={errors.mobile ? errors.mobile.message : null}
          fullWidth
          label="شماره موبایل "
          variant="outlined"
        /> 
        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
     ثبت
        </Button>

        {networkState === "SUCCESS" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ?   <p style={{color:'red'}}>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div> )}
      </form>
   
        </Card >
    )
}